import 'react-credit-cards/es/styles-compiled.css';
import React, {useContext, useState} from "react";
import {useStyles} from "../styles";
import {FormControl, TextField, Typography} from "@material-ui/core";
import { PaymentInputsWrapper, usePaymentInputs } from 'react-payment-inputs';
import images from 'react-payment-inputs/images';
import {WizardContext} from "../context";
import {PRICE_PER_RESPONSE_USD} from "../constants";

const WizardStep4 = ({goToStep}) => {
  const classes = useStyles();
  const {formData, fieldChange} = useContext(WizardContext);
  const {
    wrapperProps,
    getCardImageProps,
    getCardNumberProps,
    getExpiryDateProps,
    getCVCProps
  } = usePaymentInputs();

  const handleSubmit = async (event) => {
    event.preventDefault();
  };

  const handleCardDataChange = name => ({target: { value }}) => {
    fieldChange('paymentCard')({target: { value: {
      ...formData.paymentCard,
      [name]: value,
      error: wrapperProps.error,
    }}});
  };

  return (
    <>
      <div>
        <h4>Campaign Name</h4>
        <p><i>{formData.questionText}</i></p>

        <h4>Responses Requested</h4>
        <p>{formData.totalResponses} Requested for <a href='#' onClick={e => {e.preventDefault(); goToStep(0)}}>configured target</a></p>

        <h4>Amount due</h4>
        <p style={{ color: '#303F9F' }}><i>${formData.totalResponses * PRICE_PER_RESPONSE_USD}</i></p>

      </div>
      <FormControl className={classes.formControl}>
        <Typography id="payment-form" gutterBottom>
          Credit Card Information
        </Typography>
        <hr />
        <PaymentInputsWrapper {...wrapperProps}>
          <svg {...getCardImageProps({ images })} />
          <input {...getCardNumberProps({onChange: handleCardDataChange('number')})} style={{width: "100%"}} />
          <input {...getExpiryDateProps({onChange: handleCardDataChange('expiry')})} />
          <input {...getCVCProps({onChange: handleCardDataChange('cvc')})} />
        </PaymentInputsWrapper>
      </FormControl>
      <FormControl className={classes.formControl}>
        <Typography id="discount-code" gutterBottom>
          Discount? Add below
        </Typography>
        <TextField
          id='discount-code'
          type='text'
          fullWidth
          value={formData.discountCode}
          onChange={fieldChange('discountCode')}
        />
      </FormControl>
    </>
  );
};

export default WizardStep4;
